var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"se-ball",class:_vm.getUlLiClass,on:{"click":function($event){return _vm.selected(_vm.item,_vm.gindex,_vm.index)}}},[_c('div',{staticClass:"ball",class:[(_vm.type === 1 && Number(_vm.item.class3).toString() !== 'NaN') ? '' : ''],style:({backgroundColor:(_vm.item.selected? '#e32116':'#fff'),
        color:(_vm.item.selected? '#fff':'')
    })},[_vm._v("\n         "+_vm._s(_vm.item.class3.replace('总和','')))]),_vm._v(" "),_c('span',{staticClass:"rate"},[_vm._v(_vm._s(_vm.item.odds))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112d161a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/se-ball/index.vue
// module id = null
// module chunks = 